import React, { useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { globalStore } from '../../GlobalStore';

const PrivateRules: React.FC = observer(() => {
  useEffect(() => {
    window.scrollTo(0, 0);
    globalStore.forceWhiteHeader = true;
    
    return () => {
      globalStore.forceWhiteHeader = false;
    };
  }, []);

  const sections = [
    {
      title: '提示条款',
      content: `圆领平台（即www.yuanling.com/www.superthem.com、圆领APP及相关的应用程序，以下简称"圆领平台""圆领"或"本平台"、"我们"）制定本《法律声明》（以下简称"声明"）并提醒用户：在使用圆领网站的各项服务前，请用户务必仔细阅读并透彻理解本《法律声明》，在确认充分理解并同意后方使用相关产品和服务。一旦用户开始使用圆领服务并勾选本声明的同意选项后，将被视为对本声明内容的接受和认可。

如对本声明内容有任何疑问、意见或建议，用户可通过电子邮箱与我们联系。`
    },
    {
      title: '定义',
      content: `圆领平台：指圆领官网（域名为：www.yuanling.com/www.superthem.com）、圆领APP以及相关的应用程序。上海魔法向量网络科技有限公司（以下简称"魔法向量"）是圆领的开发者和所有者，并由魔法向量网络科技（上海）有限公司（以下简称"魔法向量"）运营。

用户：使用、登陆、浏览圆领平台的相关企业或其他主体（以下简称"服务接受方"）和个人（以下简称"服务提供方"）的合称。

用户信息：用户信息是指用户注册圆领平台账户，使用圆领平台的服务以及圆领平台为了向用户提供服务，用户提交的或者圆领平台收集的用户会员类信息，如企业名称、姓名、主营业务、行业分类、通讯地址、联系方式等，具体详见《隐私权政策》第二条所述的信息。

管理人（联系人）：是指用户授权或同意，代表用户注册和使用本平台系统或在本平台进行操作的个人。凡依据本平台流程和要求，用户提供给本平台的指定人士或在本平台上填写其个人信息的人，即是用户的管理人。本平台需要管理人（联系人）提供其个人姓名、身份证件、联系方式及其他必要的信息，如职务或相关执业证照等。

业务数据：不同于用户信息，是指圆领平台的用户利用圆领的服务工具填写、上传、下载、分发等通过圆领平台的技术服务处理的数据。`
    },
    {
      title: '一、权利归属',
      content: `1.1 圆领平台的Logo、"圆领"、"yuanling"等文字、图形及其组合，以及圆领平台的其他标识、徽记、圆领服务的名称等均属于注册商标，商标注册权人是魔法向量，其权利属于魔法向量及相关主体。未经权利人书面授权，任何人不得以任何方式展示、使用或做其他处理（包括但不限于复制、传播、展示、镜像、上传、下载），也不得向他人表明用户有权展示、使用或做其他处理。

1.2 圆领平台所有的产品、服务、技术与所有程序（以下或简称"技术服务"）的知识产权均归属于魔法向量或归经魔法向量确认的相关主体所有。经魔法向量授权，魔法向量有权在经营圆领平台期间管理及使用前述权利。

1.3 除非魔法向量另行声明，魔法向量拥有在圆领平台内发布文档等信息（包括但不限于文字、图形、图片、照片、音频、视频、图标、色彩、版面设计、电子文档）的所有权利（包括但不限于版权、商标权、专利权、商业秘密和其他所有相关权利），并授权魔法向量经营使用。未经魔法向量许可，任何人不得擅自使用如上内容（包括但不限于通过程序或设备监视、复制、转播、展示、镜像、上传、下载圆领平台内的任何内容）。被授权浏览、复制、打印和传播属于圆领平台内信息内容的，该等内容都不得用于商业目的且所有信息内容及其任何部分的使用都必须包括此权利声明。`
    },
    {
      title: '二、责任限制',
      content: `2.1 用户在圆领平台的论坛、社区，自行上传、提供、发布相关信息，包括但不限于用户名称、公司名称、 联系人及联络信息，相关图片、资讯等，该等信息均由用户自行提供，用户所提供、填写、提交的所有材料、信息、文件等皆为真实、准确、合法的；用户须对其提供的任何信息依法承担全部责任。

2.2 圆领平台上转载作品（包括论坛内容）出于传递更多信息之目的，并不代表本平台赞同其观点或证实其内容的真实性。

2.3 圆领平台在此提示，用户在使用圆领平台相关服务期间应当遵守中华人民共和国的法律，不得危害网络安全及数据安全，不得利用圆领平台的服务从事他人侵犯名誉、隐私、知识产权、个人信息和其他合法权益的活动。尽管有前述提示，圆领平台不对用户使用圆领平台服务的用途和目的承担任何责任。`
    },
    {
      title: '三、知识产权保护',
      content: `圆领平台尊重知识产权，反对并打击侵犯知识产权的行为。任何组织或个人认为圆领平台（含www.yuanling.com/www.superthem.com网页内容以及客户端页面、圆领）内容（如转载文章、云市场服务商发布的商品信息等）可能侵犯其合法权益的，可以通过向圆领平台（https://www.yuanling.com/www.superthem.com）提出书面权利通知，圆领平台将在收到知识产权权利人合格通知后依法尽快处理。`
    }
  ];

  return (
    <>
      <style>{`
        .rules-wrapper {
          background-color: #ffffff;
          min-height: 100vh;
        }
        .rules-container {
          max-width: 1400px;
          margin: 0 auto;
          width: 100%;
          padding: 60px 40px;
        }
        @media (max-width: 767px) {
          .rules-container {
            padding: 40px 16px;
          }
        }
      `}</style>
      <div className="rules-wrapper">
        <div className="rules-container">
        {/* 标题（居中） */}
        <h1 style={{
          fontSize: '32px',
          fontWeight: 'bold',
          textAlign: 'center',
          marginBottom: '20px',
          color: '#000000'
        }}>
          法律声明及隐私权政策
        </h1>
        
        {/* 发布时间-生效时间（居中） */}
        <div style={{
          textAlign: 'center',
          fontSize: '14px',
          color: '#666666',
          marginBottom: '40px'
        }}>
          2024年04月08日生效
        </div>
        
        {/* 正文：多个章节 */}
        <div style={{
          fontSize: '16px',
          lineHeight: '28px',
          color: '#333333'
        }}>
          {sections.map((section, index) => (
            <div key={index} style={{ marginBottom: '30px' }}>
              <h2 style={{
                fontSize: '18px',
                fontWeight: 'bold',
                marginBottom: '12px',
                color: '#000000'
              }}>
                {section.title}
              </h2>
              <div style={{
                fontSize: '16px',
                lineHeight: '28px',
                fontWeight: '400',
                color: '#333333',
                whiteSpace: 'pre-wrap'
              }}>
                {section.content}
              </div>
            </div>
          ))}
        </div>
        </div>
      </div>
    </>
  );
});

export default PrivateRules;
